import EditName from './edit_amount'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    initialValues: {
      goal: campaign.goal,
    },
    currencyCode: campaign.currency,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { goal: formValues.goal || 0 })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_amount',
    fields: ['goal'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditName)
